import firebase from 'firebase'
// import 'firebase/firestore'
import firebaseConfig from './firebaseConfig'
// import * as admin from 'firebase-admin'
const firebaseApp = firebase.initializeApp(firebaseConfig)

// Generate timestamp doc Ids with random - suffix in case
const milliseconds = String((new Date()).getTime())
let docTimestamp = milliseconds + '-' + Math.floor(Math.random() * 100) + 10

const db = firebaseApp.firestore()
const auth = firebaseApp.auth()
const storage = firebaseApp.storage()
const bucket = 'pool-demo-project.appspot.com'
const functions = firebaseApp.functions()
const FieldValue = firebase.firestore.FieldValue

export { firebaseApp, db, auth, storage, docTimestamp, bucket, functions, FieldValue }

// Fix firebase timestamps
// const firestore = firebase.firestore()
// const settings = { timestampsInSnapshots: true }
// firestore.settings(settings)



// WEBPACK FOOTER //
// ./src/firebaseInit.js